import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardBody,
  Label,
  Table,
} from "reactstrap";
import { useSafariPaymentReset } from "../../hooks/useSafariPaymentReset";
import CustomInput from "../../custom/CustomInput";
import CustomSelect from "../../custom/CustomSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import CircularIndeterminate from "../loader/CircularIndeterminate";
import { Autocomplete, TextField } from "@mui/material";

const InternalExamination = () => {
  const dispatch = useDispatch();
  const { isPostLoading } = useSelector((state) => state.coursereg);
  const { courseByEvents, isLoading } = useSelector(
    (state) => state.courseByEvents
  );
  const { level } = useSelector((state) => state.level);
  const data = {
    id: "27",
  };
  useEffect(() => {
    dispatch(actions.courseByEventsGetData(data));
    dispatch(actions.levelGetData());
    dispatch(actions.weekDaysGetData());
  }, []);
  const defaultProps = {
    options: courseByEvents,
    getOptionLabel: (option) => option.name,
  };
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const coursereg = {
      clientname: values.clientname,
      parent_name: values.parent_name,
      gender: values.gender,
      age: values.age,
      dob: values.dob,
      address: values.address,
      city: values.city,
      pincode: values.pincode,
      clientemail: values.clientemail,
      clientphone: values.clientphone,
      your_exam: values.your_exam,
      choose_lang: values.choose_lang,
      branch_name: values.branch_name,
      your_teacher: values.your_teacher,
      course_id: values.course_id,
      choose_lang: values.choose_lang,
      level_id: values.level_id,
      totalfees: values.totalfees,
      is_enquiry: values.is_enquiry,
      is_online_payment: values.is_online_payment,
    };
    // iOS Safari compatible redirect
    dispatch(
      actions.postCourseregDataWithBackendRedirect(coursereg, setSubmitting, resetForm)
    );
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">Ajivasan Internal Examination.</h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  clientname: "",
                  parent_name: "",
                  gender: "",
                  age: "",
                  dob: "",
                  address: "",
                  city: "",
                  pincode: "",
                  clientemail: "",
                  clientphone: "",
                  your_exam: "",
                  choose_lang: "",
                  branch_name: "",
                  your_teacher: "",
                  course_id: "",
                  choose_lang: "",
                  level_id: "",
                  totalfees: "",
                  is_enquiry: "0",
                  is_online_payment: "1",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientemail: Yup.string()
                    .required("Enter Your Email")
                    .email("Invalid Email address"),
                  clientname: Yup.string().required("required"),
                  clientphone: Yup.string().required("required"),
                  age: Yup.string().required("required"),
                  //   choose_lang: Yup.string().required("required"),
                  branch_name: Yup.string().required("required"),
                  // your_teacher: Yup.string().required("required"),
                  course_id: Yup.string().required("required"),
                  level_id: Yup.string().required("required"),
                })}
              >
                {(formProps) => {
                  const total = formProps.values.totalfees;
                  const levelProps = {
                    options: level.filter(
                      (i) => formProps.values.course_id == i.course_id
                    ),
                    getOptionLabel: (option) => option.level_type,
                  };

                  return (
                    <Form className="mt-3">
                      {console.log("formProps", formProps.values)}
                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="clientname" className="label">
                            Your Full Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientname"
                              id="clientname"
                              placeholder="Enter Your Full Name"
                              className={
                                "form-control" +
                                (formProps.errors.clientname &&
                                formProps.touched.clientname
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientname"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="parent_name" className="label">
                            Your Parent Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="parent_name"
                              id="parent_name"
                              placeholder="Enter Your Parent Name"
                              className={
                                "form-control" +
                                (formProps.errors.parent_name &&
                                formProps.touched.parent_name
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="parent_name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="gender" className="label">
                            Your Gender:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="gender"
                              id="gender"
                              placeholder="Enter Your Gender"
                              className={
                                "form-control" +
                                (formProps.errors.gender &&
                                formProps.touched.gender
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>Select Gender</option>
                              <option value={"Male"}>Male</option>
                              <option value={"Female"}>Female</option>
                            </Field>
                            <ErrorMessage
                              name="gender"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="age" className="label">
                            Student's Current Age:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="number"
                              name="age"
                              id="age"
                              placeholder="Enter Student's Current Age (In Numbers Only)"
                              className={
                                "form-control" +
                                (formProps.errors.age && formProps.touched.age
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="age"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="dob" className="label">
                            Your Date Of Birth :
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="date"
                              name="dob"
                              id="dob"
                              // placeholder="Enter Your Date Of Birth"
                              className={
                                "form-control" +
                                (formProps.errors.dob && formProps.touched.dob
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="dob"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="address" className="label">
                            Your Postal Address:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="textarea"
                              name="address"
                              id="address"
                              placeholder="Enter Your Postal Address:"
                              className={
                                "form-control" +
                                (formProps.errors.address &&
                                formProps.touched.address
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="address"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="city" className="label">
                            Your City:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="city"
                              id="city"
                              placeholder="Enter Your Residence City"
                              className={
                                "form-control" +
                                (formProps.errors.city && formProps.touched.city
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="city"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="pincode" className="label">
                            Your Pincode:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="pincode"
                              id="pincode"
                              placeholder="Enter Your Pincode"
                              className={
                                "form-control" +
                                (formProps.errors.pincode &&
                                formProps.touched.pincode
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="pincode"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="clientemail" className="label">
                            Your Email:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientemail"
                              id="clientemail"
                              placeholder="Enter Your Email"
                              className={
                                "form-control" +
                                (formProps.errors.clientemail &&
                                formProps.touched.clientemail
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientemail"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="clientphone" className="label">
                            Your Mobile:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientphone"
                              id="clientphone"
                              placeholder="Enter Your Mobile"
                              className={
                                "form-control" +
                                (formProps.errors.clientphone &&
                                formProps.touched.clientphone
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientphone"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      {/* <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="your_exam" className="label">
                            Your Exam:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="your_exam"
                              id="your_exam"
                              placeholder="Enter Your Exam"
                              className={
                                "form-control" +
                                (formProps.errors.your_exam &&
                                formProps.touched.your_exam
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option>-- Select Your Exam First --</option>
                              <option
                                value={
                                  "Prayag Sangeet Samiti - Indian Classical Vocals"
                                }
                              >
                                Prayag Sangeet Samiti - Indian Classical Vocals
                              </option>
                              <option value={"Prayag Sangeet Samiti - Sitar"}>
                                Prayag Sangeet Samiti - Sitar
                              </option>
                              <option value={"Prayag Sangeet Samiti - Tabla"}>
                                Prayag Sangeet Samiti - Tabla
                              </option>
                              <option value={"Prayag Sangeet Samiti - Kathak"}>
                                Prayag Sangeet Samiti - Kathak
                              </option>
                            </Field>
                            <ErrorMessage
                              name="your_exam"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="choose_lang" className="label">
                            Choose your language for appearing in Written
                            Examination:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="choose_lang"
                              id="choose_lang"
                              className={
                                "form-control" +
                                (formProps.errors.choose_lang &&
                                formProps.touched.choose_lang
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option>-- Select --</option>
                              <option value={"Hindi"}>Hindi</option>
                              <option value={"English"}>English</option>
                            </Field>
                            <ErrorMessage
                              name="choose_lang"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row> */}

                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="branch_name" className="label">
                            Your Branch:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="branch_name"
                              id="branch_name"
                              className={
                                "form-control" +
                                (formProps.errors.branch_name &&
                                formProps.touched.branch_name
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>
                                -- Select Your Branch --
                              </option>
                              <option value={"BANDRA WEST BRANCH"}>
                                BANDRA WEST BRANCH
                              </option>
                              <option value={"CHEMBUR EAST BRANCH"}>
                                CHEMBUR EAST BRANCH
                              </option>
                              <option value={"GHATKOPAR EAST BRANCH"}>
                                GHATKOPAR EAST BRANCH
                              </option>
                              <option value={"KANDIVALI EAST BRANCH"}>
                                KANDIVALI EAST BRANCH
                              </option>
                              <option value={"KANDIVALI WEST BRANCH"}>
                                KANDIVALI WEST BRANCH
                              </option>
                              <option value={"KEMPS CORNER, GRANT ROAD BRANCH"}>
                                KEMPS CORNER, GRANT ROAD BRANCH
                              </option>
                              <option value={"MALAD WEST BRANCH"}>
                                MALAD WEST BRANCH
                              </option>
                              <option value={"MIRA ROAD EAST BRANCH"}>
                                MIRA ROAD EAST BRANCH
                              </option>
                              <option value={"POWAI BRANCH"}>
                                POWAI BRANCH
                              </option>
                              <option value={"PRABHADEVI, DADAR WEST BRANCH"}>
                                PRABHADEVI, DADAR WEST BRANCH
                              </option>
                              <option value={"THANE W, WAGHBIL BRANCH"}>
                                THANE W, WAGHBIL BRANCH
                              </option>
                              <option value={"THANE W, POKHRAN ROAD BRANCH"}>
                                THANE W, POKHRAN ROAD BRANCH
                              </option>
                              <option value={"ANDHERI WEST BRANCH"}>
                                ANDHERI WEST BRANCH
                              </option>
                              <option value={"ANDHERI EAST BRANCH"}>
                                ANDHERI EAST BRANCH
                              </option>
                              <option value={"THANE W, RUSTOMJEE BRANCH"}>
                                THANE W, RUSTOMJEE BRANCH
                              </option>
                              <option value={"JUHU, SANTACRUZ WEST"}>
                                JUHU, SANTACRUZ WEST
                              </option>
                              <option value={"PAREL BRANCH"}>
                                PAREL BRANCH
                              </option>
                              <option value={"BORIVALI WEST BRANCH"}>
                                BORIVALI WEST BRANCH
                              </option>
                              <option value={"KALYAN BRANCH"}>
                                KALYAN BRANCH
                              </option>
                              <option value={"KOPARKHAIRANE"}>
                                KOPARKHAIRANE
                              </option>
                              <option value={"MULUND BRANCH"}>
                                MULUND BRANCH
                              </option>
                              <option value={"VIRAR WEST BRANCH"}>
                                VIRAR WEST BRANCH
                              </option>
                              <option value={"ONLINE CLASS"}>
                                ONLINE CLASS
                              </option>
                              <option value={"PRIVATE CLASS"}>
                                PRIVATE CLASS
                              </option>
                            </Field>
                            <ErrorMessage
                              name="branch_name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="your_teacher" className="label">
                            Your Teacher:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="your_teacher"
                              id="your_teacher"
                              placeholder="Enter Teacher"
                              className={
                                "form-control" +
                                (formProps.errors.your_teacher &&
                                formProps.touched.your_teacher
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="your_teacher"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="course_id" className="label">
                            Your Course:
                          </Label>
                          <InputGroup>
                            <Autocomplete
                              {...defaultProps}
                              id="course_id"
                              name="course_id"
                              getOptionSelected={(option, value) =>
                                option.id === value.id
                              }
                              onChange={(event, newValue) => {
                                console.log("new", newValue);
                                formProps.setFieldValue(
                                  `course_id`,
                                  newValue?.id ?? ""
                                );
                                formProps.setFieldValue(
                                  `totalfees`,
                                  newValue?.total_amount ?? ""
                                );
                                if (newValue?.id == "240") {
                                  formProps.setFieldValue(
                                    `level_id`,
                                    "362" ?? ""
                                  );
                                  formProps.setFieldValue(
                                    `totalfees`,
                                    "600" ?? ""
                                  );
                                }
                              }}
                              sx={{ width: "100%" }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Course Name *"
                                  variant="outlined"
                                  name="course_id"
                                  size="small"
                                  className="form-control"
                                  error={
                                    formProps.touched.course_id &&
                                    Boolean(formProps.errors.course_id)
                                  }
                                  helperText={
                                    formProps.touched.course_id &&
                                    formProps.errors.course_id
                                  }
                                />
                              )}
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      {/* {formProps.values.course_id == "241" ||
                      formProps.values.course_id == "" ? (
                        <Row className="form-group">
                          <Col md={12} className="mt-2">
                            <Label htmlFor="level_id" className="label">
                              Your Level:
                            </Label>
                            <InputGroup>
                              <Autocomplete
                                {...levelProps}
                                id="level_id"
                                name="level_id"
                                getOptionSelected={(option, value) =>
                                  option.id === value.id
                                }
                                onChange={(event, newValue) => {
                                  console.log("new", newValue);
                                  formProps.setFieldValue(
                                    `level_id`,
                                    newValue?.id ?? ""
                                  );
                                  formProps.setFieldValue(
                                    `totalfees`,
                                    newValue?.total_amount ?? ""
                                  );
                                  formProps.setFieldValue(
                                    `monthly_fee`,
                                    newValue?.monthly_fee ?? ""
                                  );
                                  formProps.setFieldValue(
                                    `reg_fee`,
                                    newValue?.reg_fee ?? ""
                                  );
                                  formProps.setFieldValue(
                                    `activity_fee`,
                                    newValue?.activity_fee ?? ""
                                  );
                                  formProps.setFieldValue(
                                    `sub_total`,
                                    newValue?.sub_total ?? ""
                                  );
                                  formProps.setFieldValue(
                                    `exact_sub_total`,
                                    newValue?.exact_sub_total ?? ""
                                  );
                                  formProps.setFieldValue(
                                    `gst`,
                                    newValue?.gst ?? ""
                                  );
                                  formProps.setFieldValue(
                                    `totalfees`,
                                    newValue?.grand_total ?? ""
                                  );
                                  formProps.setFieldValue(
                                    `week_days_id`,
                                    newValue?.week_days_id ?? ""
                                  );
                                }}
                                sx={{ width: "100%" }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Choose Level *"
                                    variant="outlined"
                                    name="level_id"
                                    size="small"
                                    className="form-control"
                                    error={
                                      formProps.touched.level_id &&
                                      Boolean(formProps.errors.level_id)
                                    }
                                    helperText={
                                      formProps.touched.level_id &&
                                      formProps.errors.level_id
                                    }
                                  />
                                )}
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )} */}
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="level_id" className="label">
                            Your Level:
                          </Label>
                          <InputGroup>
                            <Autocomplete
                              {...levelProps}
                              id="level_id"
                              name="level_id"
                              getOptionSelected={(option, value) =>
                                option.id === value.id
                              }
                              onChange={(event, newValue) => {
                                console.log("new", newValue);
                                formProps.setFieldValue(
                                  `level_id`,
                                  newValue?.id ?? ""
                                );
                                formProps.setFieldValue(
                                  `totalfees`,
                                  newValue?.total_amount ?? ""
                                );
                                formProps.setFieldValue(
                                  `monthly_fee`,
                                  newValue?.monthly_fee ?? ""
                                );
                                formProps.setFieldValue(
                                  `reg_fee`,
                                  newValue?.reg_fee ?? ""
                                );
                                formProps.setFieldValue(
                                  `activity_fee`,
                                  newValue?.activity_fee ?? ""
                                );
                                formProps.setFieldValue(
                                  `sub_total`,
                                  newValue?.sub_total ?? ""
                                );
                                formProps.setFieldValue(
                                  `exact_sub_total`,
                                  newValue?.exact_sub_total ?? ""
                                );
                                formProps.setFieldValue(
                                  `gst`,
                                  newValue?.gst ?? ""
                                );
                                formProps.setFieldValue(
                                  `totalfees`,
                                  newValue?.grand_total ?? ""
                                );
                                formProps.setFieldValue(
                                  `week_days_id`,
                                  newValue?.week_days_id ?? ""
                                );
                              }}
                              sx={{ width: "100%" }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Choose Level *"
                                  variant="outlined"
                                  name="level_id"
                                  size="small"
                                  className="form-control"
                                  error={
                                    formProps.touched.level_id &&
                                    Boolean(formProps.errors.level_id)
                                  }
                                  helperText={
                                    formProps.touched.level_id &&
                                    formProps.errors.level_id
                                  }
                                />
                              )}
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      {formProps.values.course_id == "408" ||
                      formProps.values.level_id == "682" ||
                      formProps.values.level_id == "" ? (
                        ""
                      ) : (
                        <Row className="form-group">
                          <Col md={12} className="mt-2">
                            <Label htmlFor="choose_lang" className="label">
                              Choose your language for appearing in Written
                              Examination:
                            </Label>
                            <InputGroup>
                              <Field
                                component={CustomSelect}
                                type="select"
                                name="choose_lang"
                                id="choose_lang"
                                placeholder="Enter Your Language"
                                className={
                                  "form-control" +
                                  (formProps.errors.choose_lang &&
                                  formProps.touched.choose_lang
                                    ? " is-invalid"
                                    : "")
                                }
                              >
                                <option>-- Choose your language --</option>
                                <option value={"Hindi"}>Hindi</option>
                                <option value={"English"}>English</option>
                              </Field>
                              <ErrorMessage
                                name="choose_lang"
                                component="div"
                                className="invalid-feedback"
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                      )}

                      {formProps.values.level_id !== "" ? (
                        <Row className="mt-3">
                          <Col md={10}>
                            <Label className="mt-3 mb-3 text-orange">
                              FEE STRUCTURE:
                            </Label>
                            <Table bordered>
                              <thead>
                                <tr>
                                  <th>Fees Type</th>
                                  <th>Amount [In INR]</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th scope="row">Exam & Prep Fees:</th>
                                  <th scope="row">
                                    {formProps.values.course_id == "240"
                                      ? "600"
                                      : total}
                                  </th>
                                </tr>
                                <tr>
                                  <th scope="row">Sub Total [In INR]:</th>
                                  <th scope="row">{total}</th>
                                </tr>
                                <tr>
                                  <th scope="row">Grand Total:</th>
                                  <th scope="row">
                                    INR <input value={total} readOnly />
                                  </th>
                                </tr>
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      ) : null}

                      <div className="mt-3 mb-3 row">
                        <div className="col-12">
                          <Button
                            type="submit"
                            className="register-btn"
                            size="md"
                            block
                          >
                            {isPostLoading ? (
                              <CircularIndeterminate />
                            ) : (
                              "PAY NOW"
                            )}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default InternalExamination;
